var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"min":0,"type":"number"},on:{"keyup":_vm.check_amount},model:{value:(_vm.production_movement.amount),callback:function ($$v) {_vm.$set(_vm.production_movement, "amount", $$v)},expression:"production_movement.amount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }